export default class PreparedTransactionsError extends Error {
  constructor({ code, message = 'Prepared transaction error', details }) {
    super(message);
    this.name = this.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }

    this.code = code;
    this.details = details;
  }

  getErrorByPreparedTransactionId(transactionNumber) {
    if (this.details && this.details.preparedTransactions && this.details.preparedTransactions[transactionNumber]) {
      return this.details.preparedTransactions[transactionNumber];
    }
    return undefined;
  }
}
